/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePenaltyDetailsCommand } from '../../models/create-penalty-details-command';
import { CreatePenaltyDetailsCommandResult } from '../../models/create-penalty-details-command-result';

export interface ApiPenaltyDetailsCreatePenaltyDetailsPost$Plain$Params {
      body?: CreatePenaltyDetailsCommand
}

export function apiPenaltyDetailsCreatePenaltyDetailsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiPenaltyDetailsCreatePenaltyDetailsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePenaltyDetailsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPenaltyDetailsCreatePenaltyDetailsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatePenaltyDetailsCommandResult>;
    })
  );
}

apiPenaltyDetailsCreatePenaltyDetailsPost$Plain.PATH = '/api/PenaltyDetails/CreatePenaltyDetails';
